import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { RinvioAdapter } from '../../components/fascicolo/scadenzario-rinvio/rinvio-adapter';
import { Rinvio } from '../../models/rinvio';
import { Scadenza } from '../../models/scadenza';
import { Motivo } from '../../models/tipologiche/motivo';
import { BaseForm } from '../base-Form';

declare var removeEmptyObject: any;

@Component({
    selector: 'div [scadenzario-rinvio-form]',
  templateUrl: 'scadenzario-rinvio-form.component.html'
})

export abstract class ScadenzarioRinvioForm extends BaseForm {
  scadenza: Scadenza;
  request: RinvioAdapter;
  rinvioForm: any;
  motiviOptions: Motivo[] = [];
  oraSet: string;
  minutiSet: string;

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  initRequest() {
    this.request = new RinvioAdapter(new Rinvio());
    if (this.request.ora) {
      this.oraSet = this.request.ora.substr(0, this.request.ora.indexOf(':'));
      this.minutiSet = this.request.ora.substr(this.request.ora.indexOf(':') + 1);
    } else {
      this.oraSet = '00';
      this.minutiSet = '00';
    }
  }

  createForm() {
    this.initRequest();
    this.rinvioForm = this.campiForm.group({
      id: [this.request.id],
      dataA: [this.request.dataA, Validators.required],
      ora: [this.request.ora],
      motivo: [this.request.motivo, Validators.required],
      note: [this.request.note]
    });
  }

  populateSelect() {
    if (this.motiviOptions.length === 0) {
      this.helpers.getMotiviRinvioScadenza().subscribe(response => this.motiviOptions = response);
    }
  }

  save() {
    let data = this.request.dataA;
    let date = new Date(data);
    if (this.request.ora) {
      let oraMinuti: string[] = this.request.ora.split(':');
      date.setHours(Number(oraMinuti[0]), Number(oraMinuti[1]));
    }
    this.request.dataA = date.getTime();
    this.getRequestRinvio(this.request);
  }

  abstract getScadenza(): Scadenza;
  abstract getRequestRinvio(request: RinvioAdapter);

}
